import { defaultProductionPagination } from '../../constants/consts';

export const GET_FESTIVAL = 'app/Festival/GET_FESTIVAL';
export const SET_FESTIVAL = 'app/Festival/SET_FESTIVAL';
export const GET_PERFORMANCES = 'app/Festival/GET_PERFORMANCES';
export const GET_FESTIVAL_CONTACTS = 'app/Festival/GET_FESTIVAL_CONTACTS';
export const UPDATE_FESTIVAL = 'app/Festival/UPDATE_FESTIVAL';
export const GET_COMPANIES = 'app/Festival/GET_COMPANIES';
export const GET_FESTIVAL_DESCRIPTIONS = 'app/Festival/GET_FESTIVAL_DESCRIPTIONS';
export const CREATE_FESTIVAL_DESCRIPTIONS = 'app/Festival/CREATE_FESTIVAL_DESCRIPTIONS';
export const DELETE_FESTIVAL_DESCRIPTIONS = 'app/Festival/DELETE_FESTIVAL_DESCRIPTIONS';
export const UPDATE_FESTIVAL_DESCRIPTIONS = 'app/Festival/UPDATE_FESTIVAL_DESCRIPTIONS';
export const UPDATE_FESTIVAL_INFO = 'app/Festival/UPDATE_FESTIVAL_INFO';
export const ADD_AND_UPDATE_FESTIVAL_CONTACTS = 'app/Festival/ADD_AND_UPDATE_FESTIVAL_CONTACTS';
export const CLEAR_FESTIVAL_PRODUCTIONS = 'app/Festival/CLEAR_FESTIVAL_PRODUCTIONS';
export const GET_FESTIVAL_VENUES = 'app/Festival/GET_FESTIVAL_VENUES';
export const UPDATE_FESTIVAL_VENUES = 'app/Festival/UPDATE_FESTIVAL_VENUES';
export const SET_INIT_PRODUCTIONS = 'app/Festival/SET_INIT_PRODUCTIONS';
export const GET_FESTIVAL_VIDEOS = 'app/Festival/GET_FESTIVAL_VIDEOS';
export const GET_FESTIVAL_LS_VOD = 'app/Festival/GET_FESTIVAL_LS_VOD';
export const ADD_FESTIVAL_VIDEO = 'app/Festival/ADD_FESTIVAL_VIDEO';
export const UPDATE_FESTIVAL_VIDEO = 'app/Festival/UPDATE_FESTIVAL_VIDEO';
export const DELETE_FESTIVAL_VIDEO = 'app/Festival/DELETE_FESTIVAL_VIDEO';
export const GET_FESTIVAL_IMAGES = 'app/Festival/GET_FESTIVAL_IMAGES';
export const GET_FESTIVAL_EMPLOYEES = 'app/Festival/GET_FESTIVAL_EMPLOYEES';
export const GET_FESTIVAL_BANNER = 'app/Festival/GET_FESTIVAL_BANNER';
export const GET_FESTIVAL_PRODUCTION_VIDEOS = 'app/Festival/GET_FESTIVAL_PRODUCTION_VIDEOS';
export const GET_FESTIVAL_PRODUCTION_IMAGES = 'app/Festival/GET_FESTIVAL_PRODUCTION_IMAGES';
export const GET_FESTIVAL_SEARCH_PRODUCTIONS_LIST = 'app/Festival/GET_FESTIVAL_SEARCH_PRODUCTIONS_LIST';
export const GET_FESTIVAL_TRANSLATIONS = 'app/Company/GET_FESTIVAL_TRANSLATIONS';
export const UPDATE_FESTIVAL_TRANSLATIONS = 'app/Company/UPDATE_FESTIVAL_TRANSLATIONS';
export const DELETE_FESTIVAL_TRANSLATIONS = 'app/Company/DELETE_FESTIVAL_TRANSLATIONS';
export const SET_FESTIVAL_PRODUCTION_RENTAL_ACTION = 'app/SET_FESTIVAL_PRODUCTION_RENTAL_ACTION';
export const UPDATE_RENTAL_INCLUDES_ACTION = 'app/Company/UPDATE_RENTAL_INCLUDES_ACTION';
export const GET_FESTIVAL_YOUNG_ARTIST_PROGRAM = 'app/Company/GET_FESTIVAL_YOUNG_ARTIST_PROGRAM';
export const DELETE_FESTIVAL_YOUNG_ARTIST_PROGRAM = 'app/Company/DELETE_FESTIVAL_YOUNG_ARTIST_PROGRAM';
export const CREATE_FESTIVAL_YOUNG_ARTIST_PROGRAM = 'app/Company/CREATE_FESTIVAL_YOUNG_ARTIST_PROGRAM';
export const GET_FESTIVAL_COMPANY = 'app/Company/GET_FESTIVAL_COMPANY';
export const CREATE_FESTIVAL_COMPANY = 'app/Company/CREATE_FESTIVAL_COMPANY';
export const DELETE_FESTIVAL_COMPANY = 'app/Company/DELETE_FESTIVAL_COMPANY';
export const GET_ABOUT_FESTIVAL_VIDEO = 'app/Festival/GET_ABOUT_FESTIVAL_VIDEO';
export const GET_FESTIVAL_REVIEWS = 'app/Company/GET_FESTIVAL_REVIEWS';
export const GET_FESTIVAL_PRODUCTION_REVIEWS = 'app/Company/GET_FESTIVAL_PRODUCTION_REVIEWS';

export const PRODUCTIONS_TYPES = {
  published: 'published',
  unpublished: 'unpublished',
};

export const defaultFestivalProductionsPagination = defaultProductionPagination;

export const editFestivalTabValues = {
  seasons: 'seasons',
  rentals: 'rentals',
  videos: 'videos',
  photos: 'photos',
  reviews: 'reviews',
  festivalInfo: 'festival-info',
  digitalPresence: 'digital-presence',
  staffManagement: 'staff-management',
  contactInfo: 'contact-info',
};
